import styled from "styled-components";

export const StyledWelcome = styled.div<{
  $height: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${({ $height }) => $height}px;
  background-color: var(--color-background);
`;
